export default {
  app: {
    title: 'Login da Equipa Bookshop Cafe',
    loadingApp: 'A carregar aplicação...',
    loggedOut: 'Sessão terminada com sucesso',
  },
  language: {
    en: 'EN',
    pt: 'PT',
    label: 'Idioma',
  },
  roles: {
    SUPERADMIN: '0 Superadmin',
    ADMIN: '1 Admin',
    MANAGER: '2 Manager',
    USER: '3 Utilizador',
  },
  menus: {
    app: 'App',
    scenario: 'Cenário',
    profile: 'Perfil',
    logout: 'Terminar sessão',
    version: 'Versão',
    darkMode: 'Modo escuro',
    products: 'Produtos',
    productCategories: 'Categorias de Produtos',
    manageUsers: 'Gerir utilizadores',
    new: 'Novo',
    load: 'Carregar',
    loadRecent: 'Carregar recente',
    noRecentScenarios: 'Sem cenários recentes',
    edit: 'Editar',
    duplicate: 'Duplicar',
    saveScenarioBaseState: 'Guardar estado base do cenário',
    reset: 'Repor',
    archiveScenario: 'Arquivar cenário',
    archivedScenarios: 'Cenários arquivados',
    deleteScenario: 'Apagar cenário',
  },
  header: {
    scenario: 'Cenário:',
    untitledScenario: 'Cenário sem nome',
    hello: 'Olá',
  },
  search: {
    placeholder: 'Pesquisar mesas, pessoas ou produtos...',
    button: 'Pesquisar',
    clear: 'Limpar pesquisa',
    resultsTitle: 'Resultados da pesquisa',
    person: 'Pessoa',
    noMatches: 'Não foram encontradas mesas.',
  },
  scenario: {
    loadTitle: 'Carregar Cenário',
    empty: 'Não existem cenários guardados.',
    loadSuccess: 'Cenário carregado com sucesso',
    archivedTitle: 'Cenários Arquivados',
    archivedDescription: 'Clique num cenário para o restaurar e carregar.',
    archivedEmpty: 'Não existem cenários arquivados.',
    restore: 'Restaurar',
    newTitle: 'Novo Cenário',
    duplicateTitle: 'Duplicar Cenário',
    editTitle: 'Editar Cenário',
    createButton: 'Criar Cenário',
    duplicateButton: 'Duplicar Cenário',
    saveButton: 'Guardar Alterações',
    name: 'Nome do Cenário',
    columns: 'Colunas',
    rows: 'Linhas',
    setDefault: 'Definir como cenário padrão',
    showPrices: 'Mostrar preços nas orders',
    itemizePrintItems: 'Discriminar itens ao imprimir pedidos',
    note: 'Alterar linhas ou colunas atualiza a grelha imediatamente. As mesas existentes mantêm-se no lugar.',
    close: 'Fechar',
    saveSuccess: 'Cenário guardado com sucesso',
    createSuccess: 'Cenário criado com sucesso',
    duplicateSuccess: 'Cenário duplicado com sucesso',
    createError: 'Não foi possível criar o cenário.',
    duplicateError: 'Não foi possível duplicar o cenário.',
    updateSuccess: 'Cenário atualizado com sucesso',
    deleteSuccess: 'Cenário apagado com sucesso',
    archiveSuccess: 'Cenário arquivado com sucesso',
    restoreSuccess: 'Cenário restaurado com sucesso',
    resetSuccess: 'Cenário reposto',
    resetError: 'Não foi possível repor o cenário.',
    baseStateSaveSuccess: 'Estado base do cenário guardado com sucesso',
    baseStateSaveError: 'Não foi possível guardar o estado base do cenário.',
    baseStateMissingError: 'Este cenário ainda não tem um estado base guardado.',
    setDefaultSuccess: 'Cenário padrão definido para "{name}"',
    reservedName: 'Este nome de cenário está reservado. Escolha outro.',
    requireName: 'Introduza um nome para o cenário antes de guardar.',
    requireNameCreate: 'O nome do cenário é obrigatório.',
    notFound: 'Cenário não encontrado',
    notFoundLocal: 'Cenário não encontrado localmente.',
    noRecentFound: 'Não foi encontrado um cenário recente.',
    loadRecentError: 'Não foi possível carregar o cenário recente.',
    loadError: 'Não foi possível interpretar o cenário guardado',
    saveError: 'Não foi possível guardar o cenário',
    deleteError: 'Não foi possível apagar o cenário',
    updateError: 'Não foi possível atualizar o cenário.',
    archiveError: 'Não foi possível arquivar o cenário.',
    restoreError: 'Não foi possível restaurar o cenário.',
    setDefaultError: 'Não foi possível definir o cenário padrão.',
    confirmDelete: 'Apagar este cenário?',
  },
  table: {
    tables: 'Mesas',
    addTable: 'Adicionar Mesa',
    addWall: 'Adicionar Parede',
    delete: 'Apagar',
    undo: 'Desfazer',
    redo: 'Refazer',
    tableColor: 'Cor da mesa',
    wallColor: 'Cor da parede',
    editTitle: 'Editar Mesa',
    autosaveNote: 'As alterações são guardadas automaticamente. Use Concluir quando terminar.',
    printOrder: 'Imprimir Pedido',
    itemizePrint: 'Discriminar itens',
    itemizePrintHint: 'Altere esta opção em Editar Cenário.',
    done: 'Concluir',
    close: 'Fechar',
    closeAria: 'Fechar',
    name: 'Nome',
    person: 'Pessoa',
    defaultColor: 'Padrão',
    products: 'Produtos',
    product: 'Produto',
    productName: 'Nome do produto',
    productNote: 'Notas',
    total: 'Total',
    totalNoPricesHint: 'produtos sem valor contam como 0,00 €',
    addProductNote: 'Adicionar Notas',
    quantityShort: 'Qtd',
    addProduct: 'Adicionar produto',
    pasteProducts: 'Colar produtos',
    copyProducts: 'Copiar produtos',
    removeAllProducts: 'Remover todos os produtos',
    tableNameRequired: 'O nome da mesa não pode ficar vazio',
    updated: 'Mesa atualizada',
    noProductsToCopy: 'Não existem produtos para copiar',
    productsCopied: 'Produtos copiados',
    productsPasted: 'Produtos colados',
    noValidProductsToPaste: 'Não existem produtos válidos para colar',
    noProductsToPrint: 'Não existem produtos para imprimir',
    orderTitle: 'Pedido',
    orderFor: 'Pedido para {name}',
    dragToReorder: 'Arrastar para reordenar',
    handling: 'A tratar',
    delivered: 'Entregue',
    paid: 'Pago',
    increaseQuantity: 'Aumentar quantidade',
    decreaseQuantity: 'Diminuir quantidade',
    addedHistory: 'Mesa {name} adicionada',
    editedHistory: 'Mesa {name} editada',
    deletedHistory: 'Mesa {name} apagada',
    reorderedHistory: 'Mesas reordenadas',
    resetHistory: 'Cenário reposto',
    initialHistory: 'Estado inicial',
    readonly: 'Só leitura',
  },
  modal: {
    closeManageUsers: 'Fechar gestão de utilizadores',
    close: 'Fechar',
  },
  confirm: {
    deleteTitle: 'Confirmar eliminação',
    delete: 'Apagar',
    cancel: 'Cancelar',
    deleteScenarioBody: 'Tem a certeza de que pretende apagar o cenário "{name}"?',
    deleteUserBody: 'Tem a certeza de que pretende apagar o utilizador "{name}"?',
    deleteProductBody: 'Tem a certeza de que pretende apagar o produto "{name}"?',
    deleteCategoryBody: 'Tem a certeza de que pretende apagar a categoria "{name}"?',
  },
  profile: {
    title: 'Perfil',
    email: 'Email',
    displayName: 'Nome de exibição',
    changePassword: 'Alterar palavra-passe',
    changePin: 'Alterar PIN',
    cancelPasswordChange: 'Cancelar alteração da palavra-passe',
    cancelPinChange: 'Cancelar alteração do PIN',
    currentPassword: 'Palavra-passe atual',
    newPassword: 'Nova palavra-passe',
    confirmNewPassword: 'Confirmar nova palavra-passe',
    newPin: 'Novo PIN',
    confirmNewPin: 'Confirmar novo PIN',
    save: 'Guardar Alterações',
    saving: 'A guardar...',
    close: 'Fechar',
    updated: 'Perfil atualizado com sucesso',
    updateError: 'Não foi possível atualizar o perfil.',
    requireDisplayName: 'O nome de exibição é obrigatório.',
    requireEmail: 'O email é obrigatório.',
    requireCurrentPassword: 'A palavra-passe atual é obrigatória.',
    requireNewPassword: 'A nova palavra-passe é obrigatória.',
    requireNewPin: 'O novo PIN é obrigatório.',
    minPassword: 'A nova palavra-passe deve ter pelo menos 8 caracteres.',
    passwordMismatch: 'A confirmação da nova palavra-passe não corresponde.',
    invalidPin: 'O PIN deve ter entre 4 e 6 dígitos.',
    pinMismatch: 'A confirmação do PIN não corresponde.',
  },
  users: {
    title: 'Gerir Utilizadores',
    loading: 'A carregar utilizadores...',
    empty: 'Não existem utilizadores disponíveis.',
    addUser: '+ Adicionar Utilizador',
    editUser: 'Editar Utilizador',
    createUser: 'Criar Utilizador',
    email: 'Email',
    displayName: 'Nome de exibição',
    password: 'Palavra-passe',
    newPasswordOptional: 'Nova palavra-passe (opcional)',
    pin: 'PIN',
    newPinOptional: 'Novo PIN (opcional)',
    active: 'Ativo',
    inactive: 'Inativo',
    role: 'Função',
    close: 'Fechar',
    saveChanges: 'Guardar Alterações',
    createButton: 'Criar Utilizador',
    deleteButton: 'Apagar Utilizador',
    saving: 'A guardar...',
    deleting: 'A apagar...',
    updated: 'Utilizador atualizado com sucesso',
    created: 'Utilizador criado com sucesso',
    deleted: 'Utilizador apagado com sucesso',
    reLoginInfo: 'A sua sessão atual pode precisar de novo login para refletir alterações de função.',
    loadError: 'Não foi possível carregar os utilizadores.',
    saveError: 'Não foi possível guardar o utilizador.',
    deleteError: 'Não foi possível apagar o utilizador.',
    requireFields: 'Email e nome de exibição são obrigatórios.',
    requirePassword: 'A palavra-passe é obrigatória para novos utilizadores.',
    requirePin: 'O PIN é obrigatório para novos utilizadores.',
    addUserAria: 'Adicionar utilizador',
  },
  products: {
    title: 'Gerir Produtos',
    loading: 'A carregar produtos...',
    empty: 'Não existem produtos disponíveis.',
    addProduct: '+ Adicionar Produto',
    addProductAria: 'Adicionar produto',
    editProduct: 'Editar Produto',
    createProduct: 'Criar Produto',
    editingModeTitle: 'A editar produto existente',
    creatingModeTitle: 'A criar novo produto',
    switchToCreate: 'Novo produto',
    editingHint: 'Para criar um novo produto, carregue em "Novo produto".',
    id: 'ID do Produto',
    category: 'Categoria',
    name: 'Nome do Produto',
    value: 'Valor (EUR)',
    valueShort: '{value} €',
    valuePlaceholder: 'Opcional',
    noCategory: 'Sem categoria',
    noCategoriesAvailable: 'Sem categorias disponíveis',
    uncategorized: 'Sem categoria',
    active: 'Ativo',
    inactive: 'Inativo',
    close: 'Fechar',
    saveChanges: 'Guardar Alterações',
    createButton: 'Criar Produto',
    deleteButton: 'Apagar Produto',
    saving: 'A guardar...',
    deleting: 'A apagar...',
    created: 'Produto criado com sucesso',
    updated: 'Produto atualizado com sucesso',
    deleted: 'Produto apagado com sucesso',
    loadError: 'Não foi possível carregar os produtos.',
    requireId: 'O ID do produto é obrigatório.',
    requireCategory: 'A categoria do produto é obrigatória.',
    requireValidValue: 'O valor do produto tem de ser um número válido não negativo.',
    saveError: 'Não foi possível guardar o produto.',
    deleteError: 'Não foi possível apagar o produto.',
    requireName: 'O nome do produto é obrigatório.',
  },
  productCategories: {
    title: 'Gerir Categorias de Produtos',
    loading: 'A carregar categorias...',
    empty: 'Não existem categorias disponíveis.',
    addCategory: '+ Adicionar Categoria',
    addCategoryAria: 'Adicionar categoria',
    editCategory: 'Editar Categoria',
    createCategory: 'Criar Categoria',
    editingModeTitle: 'A editar categoria existente',
    creatingModeTitle: 'A criar nova categoria',
    switchToCreate: 'Nova categoria',
    editingHint: 'Para criar uma nova categoria, carregue em "Nova categoria".',
    name: 'Nome da Categoria',
    internalId: 'ID Interno da Categoria',
    internalIdPlaceholder: 'Ex.: swt',
    internalIdHint: 'Usado para sugerir automaticamente IDs de produto.',
    noInternalId: 'Sem ID interno',
    active: 'Ativo',
    inactive: 'Inativa',
    close: 'Fechar',
    saveChanges: 'Guardar Alterações',
    createButton: 'Criar Categoria',
    deleteButton: 'Apagar Categoria',
    saving: 'A guardar...',
    deleting: 'A apagar...',
    created: 'Categoria criada com sucesso',
    updated: 'Categoria atualizada com sucesso',
    deleted: 'Categoria apagada com sucesso',
    loadError: 'Não foi possível carregar as categorias.',
    saveError: 'Não foi possível guardar a categoria.',
    deleteError: 'Não foi possível apagar a categoria.',
    requireName: 'O nome da categoria é obrigatório.',
    requireInternalId: 'O ID interno da categoria é obrigatório.',
    invalidInternalId: 'O ID interno da categoria só pode conter letras minúsculas, números e underscores.',
  },
  login: {
    introOnline: 'Inicie sessão para aceder ao POS.',
    backendUnavailable: 'O servidor está indisponível neste momento. Verifique a ligação e tente novamente.',
    email: 'Email',
    user: 'Utilizador',
    password: 'Palavra-passe',
    signIn: 'Entrar',
    signingIn: 'A entrar...',
    pinTitle: 'Login por PIN',
    pinDescription: 'Introduza o PIN para desbloquear rapidamente o POS.',
    pin: 'PIN',
    usePin: 'Usar PIN',
    pinSignIn: 'Entrar com PIN',
    noUsersAvailable: 'Sem utilizadores disponíveis',
    pinEmailRequired: 'Introduza primeiro o email para usar login por PIN.',
    pinRequired: 'O PIN é obrigatório.',
    invalidCredentials: 'Não foi possível iniciar sessão. Verifique o utilizador selecionado e a palavra-passe.',
    expired: 'A sua sessão anterior expirou. Inicie sessão novamente.',
    error: 'Não foi possível iniciar sessão',
  },
  passwordReset: {
    forgotPassword: 'Recuperar palavra-passe?',
    requestTitle: 'Recuperar palavra-passe',
    requestDescription: 'Introduza o email do utilizador e enviaremos um link de reset se a conta estiver ativa.',
    email: 'Email',
    cancel: 'Cancelar',
    sendLink: 'Enviar link de reset',
    sending: 'A enviar...',
    requestSuccess: 'Se a conta existir, foi enviado um email com o link de reset.',
    requestError: 'Não foi possível enviar o email de reset neste momento.',
    requireEmail: 'O email é obrigatório.',
    validatingTitle: 'A validar link de reset',
    validatingBody: 'Estamos a validar o seu link de reset de palavra-passe.',
    resetTitle: 'Definir nova palavra-passe',
    resetDescription: 'Introduza abaixo a sua nova palavra-passe.',
    resetDescriptionNamed: 'Introduza uma nova palavra-passe para {name}.',
    newPassword: 'Nova palavra-passe',
    confirmPassword: 'Confirmar nova palavra-passe',
    resetButton: 'Repor palavra-passe',
    resetting: 'A repor...',
    resetSuccess: 'Palavra-passe atualizada com sucesso. Já pode iniciar sessão.',
    resetError: 'Não foi possível repor a palavra-passe.',
    requirePassword: 'A nova palavra-passe é obrigatória.',
    minPassword: 'A nova palavra-passe deve ter pelo menos 8 caracteres.',
    passwordMismatch: 'A confirmação da palavra-passe não corresponde.',
    invalidTitle: 'Link de reset inválido',
    invalidBody: 'Este link de reset é inválido ou já não está disponível.',
    expiredBody: 'Este link de reset expirou. Peça um novo link no ecrã de login.',
    usedTitle: 'Palavra-passe já reposta',
    usedBody: 'Este link de reset já foi usado. Pode entrar com a nova palavra-passe ou pedir outro link.',
    invalidToken: 'O link de reset é inválido.',
    backToLogin: 'Voltar ao login',
  },
  passwordInput: {
    show: 'Mostrar valor',
    hide: 'Esconder valor',
  },
  auth: {
    sensitiveTitle: 'Password obrigatória',
    sensitiveDescription: 'Introduza a password para aceder a esta área protegida.',
    sensitivePassword: 'Password',
    continue: 'Continuar',
    cancel: 'Cancelar',
  },
  status: {
    online: 'Online',
    syncing: 'A sincronizar',
    waitingForLock: 'À espera do bloqueio de edição',
    conflictDetected: 'Conflito detetado',
    syncFailed: 'Falha na sincronização',
    reloginRequired: 'Novo login necessário',
    conflictChanges: '{count} alteração(ões) em conflito',
    pendingChanges: '{count} alteração(ões) pendente(s)',
    noPendingChanges: 'Sem alterações pendentes',
    lockedWillRetry: 'As alterações locais estão seguras e vão sincronizar assim que este cenário voltar a ficar editável.',
    syncNow: 'Sincronizar agora',
    useCloudVersion: 'Usar versão cloud',
    saveMineAsCopy: 'Guardar a minha como cópia',
    replaceCloudWithMine: 'Substituir cloud pela minha',
    loadLatest: 'Usar versão cloud',
    keepAsCopy: 'Guardar a minha como cópia',
    moreInfo: 'Mais informação',
    loadLatestHelp: 'Descarta as alterações locais em conflito deste cenário e carrega a versão mais recente da cloud.',
    keepAsCopyHelp: 'Guarda o trabalho local em conflito como um novo cenário cópia e continua a partir dessa cópia.',
    replaceCloudWithMineHelp: 'Substitui a versão na cloud deste cenário pelas tuas alterações locais atuais.',
    conflictResolvedWithLatest: 'Foi carregada a versão mais recente da cloud.',
    conflictSavedAsCopy: 'O trabalho local foi guardado como "{name}".',
    conflictResolveError: 'Não foi possível carregar a versão mais recente.',
    conflictCopyError: 'Não foi possível guardar o trabalho em conflito como cópia.',
    conflictOverwriteSuccess: 'A versão da cloud foi substituída pelas alterações locais.',
    conflictOverwriteError: 'Não foi possível substituir a versão da cloud pelas alterações locais.',
    logout: 'Terminar sessão',
  },
  presence: {
    editingBadge: 'Bloqueio de edição',
    readOnlyBadge: 'Só leitura',
    availableBadge: 'Disponível',
    editingTitle: 'Está a editar este cenário',
    readOnlyTitle: 'Este cenário está bloqueado para edição',
    availableTitle: 'Não existe nenhum editor ativo neste momento',
    requestPendingTitle: 'Pedido de acesso enviado',
    requestDeniedTitle: 'Pedido de acesso recusado',
    editingMessage: 'As alterações deste dispositivo podem ser guardadas normalmente.',
    availableMessage: 'Nenhum editor ativo está a usar este cenário. Assuma a edição quando estiver pronto para fazer alterações.',
    requestDeniedMessage: 'O seu pedido de acesso foi recusado. Pode voltar a pedir acesso se ainda precisar de editar este cenário.',
    readOnlyMessage: '{name} está a editar este cenário. Pode continuar a ver tudo, mas as alterações ficam desativadas aqui.',
    someone: 'Alguém',
    noEditorMessage: 'Não foi detetado nenhum editor ativo neste momento.',
    requestPendingNote: 'O seu pedido de acesso está a aguardar aprovação.',
    requestDeniedReason: 'Motivo: {reason}',
    requestReceived: '{name} pediu acesso para editar este cenário.',
    claimEditing: 'Assumir edição',
    releaseEditing: 'Libertar edição',
    returnEditing: 'Devolver controlo a {{name}}',
    releasePendingButton: 'A libertar em breve',
    releasePendingEditor: 'A devolver controlo a {{name}} assim que a sincronização terminar',
    releasePendingForYou: '{name} está a devolver-lhe o controlo.',
    requestAccess: 'Pedir acesso',
    takeOver: 'Assumir controlo',
    approveRequest: 'Permitir edição',
    denyRequest: 'Recusar pedido',
    denyReasonTitle: 'Recusar pedido de acesso',
    denyReasonMessage: 'Adicione um motivo curto para o requester perceber porque é que o acesso foi recusado.',
    denyReasonLabel: 'Motivo',
    denyReasonPlaceholder: 'Exemplo: ainda estou a terminar alterações neste cenário.',
    takeOverSuccess: 'O controlo de edição passou para este dispositivo.',
    takeOverError: 'Não foi possível assumir este cenário neste momento.',
    claimEditingSuccess: 'O controlo de edição ficou ativo neste dispositivo.',
    claimEditingError: 'Não foi possível iniciar a edição neste momento.',
    releaseEditingSuccess: 'O controlo de edição foi libertado para este cenário.',
    returnEditingSuccess: 'O controlo de edição voltou para {{name}}.',
    releaseEditingSyncError: 'Aguarda que as tuas últimas alterações ao cenário terminem de sincronizar antes de libertar a edição.',
    releaseEditingError: 'Não foi possível libertar a edição neste momento.',
    requestSent: 'Pedido de acesso enviado.',
    requestError: 'Não foi possível pedir acesso neste momento.',
    requestApproved: 'Acesso de edição concedido.',
    requestApproveSyncError: 'Aguarda que as tuas últimas alterações ao cenário terminem de sincronizar antes de conceder acesso.',
    requestApproveError: 'Não foi possível aprovar o pedido de acesso.',
    requestDenied: 'Pedido de acesso recusado.',
    requestDenyError: 'Não foi possível recusar o pedido de acesso.',
    lockLost: 'Este dispositivo já não tem acesso de edição ao cenário atual. O cenário fica em modo só leitura até recuperar o controlo.',
    tableReadonly: 'Este cenário está em modo só leitura neste dispositivo. Pode consultar a mesa, mas as alterações ficam desativadas até ter acesso de edição.',
  },
  session: {
    warningTitle: 'Sessão a expirar em breve',
    warningBody: 'Faltam menos de 3 minutos para a sessão online expirar.',
    staySignedIn: 'Continuar com sessão',
  },
  toolbar: {
    stop: 'Parar',
    history: 'Histórico',
    tools: 'Ferramentas',
    appearance: 'Aspeto',
  },
  indicators: {
    deleteMode: 'Modo apagar ativo - clicar remove mesas ou paredes',
    wallMode: 'Modo parede ativo - clique e arraste para desenhar paredes',
  },
};
